<template>
  <div>
    <div style="background-color: #FFFFFF">
      <flexbox class="py-2" v-if="!isEmptyObject(address)">
        <flexbox-item class="text-left " :span="11">
          <flexbox class="py-2" orient="vertical">       
            <flexbox class="py-2">
              <flexbox-item v-if="address.name" class="text-left pl-3">{{$t('cart.address.name')}}：{{address.name}}</flexbox-item>
              <flexbox-item v-else class="text-left pl-3">{{$t('cart.address.mobile')}}</flexbox-item>
              <flexbox-item class="text-right pr-3">{{address.mobile}}</flexbox-item>
            </flexbox>
            <flexbox-item class="px-3">{{address.province}} {{address.city}} {{address.district}} {{address.detail}}</flexbox-item>
          </flexbox>
        </flexbox-item>
        <flexbox-item class="text-left pr-3">
          <x-icon type="ios-arrow-forward" size="18"></x-icon>
        </flexbox-item>
      </flexbox>
      <flexbox v-else class="p-3">
        <flexbox-item class="text-center pl-3" :span="12" @click="$router.push('/cart/address/create')">      
          <h5>+ {{$t('cart.address.create')}}</h5>
        </flexbox-item>
      </flexbox>
    </div>
  </div>
</template>
<script type="text/javascript">

import {FITFormCard} from '@/components' 
import { mapGetters } from 'vuex'
import { Cell,Group,Flexbox, FlexboxItem } from 'vux'

export default {
  name: 'AddressEntry',
  components: {
    Cell,
    Group,
    Flexbox, 
    FlexboxItem
  },
  props: {
    address:Object
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    isEmptyObject(obj) {
      if (obj == null) {
        return true;
      }
      for (var key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    }
  },
}

</script>
<style type="text/css" scoped>

</style>




// WEBPACK FOOTER //
// src/Cart/components/AddressEntry.vue